class WebSocketManager {
    constructor() {
        this.socket = null;
        this.handlers = new Map();
    }

    connect(url, userId, storeId, JWT, language_code) {
        if (this.socket) return;

        this.socket = new WebSocket(url);

        this.socket.onopen = () => {

            this.send({
                action: "authWebSocket",
                userId,
                storeId,
                JWT,
                language_code,
            });
        };

        this.socket.onmessage = (event) => {
            const data = JSON.parse(event.data);

            const handler = this.handlers.get(data.action);
            if (handler) handler(data);
        };

        this.socket.onclose = () => {
            this.socket = null;
            setTimeout(() => this.connect(url, userId, storeId, JWT, language_code), 5000);
        };

        this.socket.onerror = (error) => {
        };
    }

    send(message) {
        if (this.socket && this.socket.readyState === WebSocket.OPEN) {
            this.socket.send(JSON.stringify(message));
        } else {
        }
    }

    addHandler(action, handler) {
        this.handlers.set(action, handler);
    }

    removeHandler(action) {
        this.handlers.delete(action);
    }
}

export const webSocketManager = new WebSocketManager();